import { Component, inject } from '@angular/core';
import { ActivityMomentService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ActivityMomentCreateDto,
  ActivityMomentDto,
  ActivityMomentExcelDownloadDto,
  ActivityMomentUpdateDto,
} from '../proxy/controlling/dtos/activity-moment';
import { ACTIVITYMOMENT_CONFIG, ACTIVITYMOMENT_FIELDS } from './activity-moment.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-activity-moment',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ActivityMomentService, ConfirmationService],
  templateUrl: './activity-moment.html',
  styleUrl: './activity-moment.scss',
})
export class ActivityMoment extends BaseCrudComponent<
  ActivityMomentDto,
  ActivityMomentCreateDto,
  ActivityMomentUpdateDto,
  ActivityMomentExcelDownloadDto
> {
  service = inject(ActivityMomentService);
  config = ACTIVITYMOMENT_CONFIG;
  fields = ACTIVITYMOMENT_FIELDS;

  protected prepareUpdateDto(data: any, selected: ActivityMomentDto): ActivityMomentUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ActivityMoment';
  }
}
